module.exports = __webpack_public_path__ + "img/module_yhxt_icon.dce0e5cb.png";